import React, { useCallback, useState } from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'

import { icons, ColourButton, Spacer } from 'portal/lib/primitives'
import { useModuleIds } from 'portal/lib/hooks'
import { sizes } from '@qflow/theme'

import { trackMixpanel } from 'portal/store/mixpanel/actions'
import { OneClickExport } from './OneClickExport'

export function OneClickExportButton({ filters, onSuccess, disabled = false }) {
  const { oceWorking } = useSelector(state => state.records.exports)
  const dispatch = useDispatch()
  const { accountId, projectId, moduleName } = useModuleIds()

  const [isOCEModalOpen, setIsOCEModalOpen] = useState(false)

  const OCE_MODAL_OPEN = 'frontend_records_ocl_export_modal_open'
  const trackOCEModalOpened = useCallback(() => {
    dispatch(
      trackMixpanel(OCE_MODAL_OPEN, {
        record_type: moduleName,
        project_id: projectId,
        account_id: accountId
      })
    )
  }, [accountId, dispatch, moduleName, projectId])

  const openOneClickExportModal = () => {
    setIsOCEModalOpen(true)
    trackOCEModalOpened()
  }

  return (
    <>
      <OneClickExportButtonStyled
        id="OneClickExportButton"
        onClick={openOneClickExportModal}
        disabled={oceWorking || disabled}
      >
        {!oceWorking && <icons.Download size={sizes.SMALL} />}
        {oceWorking && <icons.Loading size={sizes.SMALL} />}
        <Spacer.Fine />
        One Click LCA Export
      </OneClickExportButtonStyled>
      {isOCEModalOpen && (
        <OneClickExport
          filters={filters}
          onSuccess={onSuccess}
          setIsOCEModalOpen={setIsOCEModalOpen}
        />
      )}
    </>
  )
}

const OneClickExportButtonStyled = styled(ColourButton.Basic)`
  min-width: 7rem;
`
